import { linkHost } from "../config";

export const linkHostRegex = /%host%/g;

export default function replaceLinkHost(message: string) {
  return message.replace(linkHostRegex, linkHost || "");
}
